import React from 'react';
import classNames from 'classnames';
import { getClassName } from '../../utils/index.js';

var ButtonGroup = function ButtonGroup(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return (
    /*#__PURE__*/
    React.createElement("div", {
      className: classNames(getClassName('btn-group'), className)
    }, children)
  );
};

export { ButtonGroup as default };